import PropTypes from 'prop-types';
import React from 'react';
import Grid from '@material-ui/core/Grid';
import Dialog from '@material-ui/core/Dialog';
import Transition from '../dialogs/Transition';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Zoom from '@material-ui/core/Zoom';
import moment from 'moment';

import _ from "lodash";
import { withStyles } from '@material-ui/core/styles';
import Button from "@material-ui/core/Button";
import FormComponent from "../FormComponent";

//- graphics
import CircularProgress from "@material-ui/core/CircularProgress";
import GreenChecked from '../../images/icons/greenChecked.svg';
import AuthUserContainer from "../../containers/AuthUser";
import FormTextArea from "../form/FormTextArea";
import UserPicker from "../advancedForm/UserPicker";
import FormDatePicker from "../form/FormDatePicker";
import FormTimePicker from "../form/FormTimePicker";

import TimeClockContainer from '../../containers/TimeClock/TimeClock';
import {post} from "../../modules/utility";
import ErrorIcon from "@material-ui/icons/Error";
import TimeClockLocationSelect from '../advancedForm/TimeClockLocationSelect';

function styles () {
	return {
		inner: {
			padding: '40px 30px',
		},
		dialogTitle : {
			fontSize : 20,
			borderBottom : '1px solid #eee',
			paddingBottom : 5,
			marginBottom : 10,
			fontWeight : 300,
			display : 'flex',
			justifyContent : 'space-between',
		},
		dialogRoot: {
			//overflow: 'visible'
			alignItems : 'end'
		},
		closeButton: {
			position: 'absolute',
			right: 15,
			top: 15,
			color: '#555',
		},
		addButton : {
			//verticalAlign : 'middle',
			//textDecoration: 'none',
			//marginBottom: 0,
			//borderRadius: 100,
			padding: '10px 35px',
			fontSize : 16,
			marginTop : 20,
			color : 'white',
			marginRight : 10,
		},
		greenCheckedIcon : {
			display: 'inline-block',
			width: 33,
			height: 33,
			backgroundImage: `url('${GreenChecked}')`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			verticalAlign: 'middle',
			marginRight : 2,
			marginLeft : 5,
		},
		isSaving : {
			marginLeft : 20,
			fontSize : 16,
			color : '#1565C0',
		},
		savingSuccessful : {
			marginLeft : 20,
			fontSize : 16,
			color : '#2E7D32',
		},
		pleaseSelect : {
			fontStyle : 'italic',
			color : '#777',
		},
		currentShiftContainer : {
			border : `1px solid #eee`,
			backgroundColor : '#fcfcfc',
			padding : `20px 20px`,
			margin : '20px 0px',
			borderRadius : 5,
		},
		currentShiftTitle : {
			display : 'flex',
			alignItems : 'center',
			fontSize : 17,
		},
		errorIcon : {
			color:'#F44336',
			marginRight : 10,
		},
		currentLabel : {
			color : '#666',
			marginLeft : 30,
			marginRight : 5
		},
		currentValue : {
			fontWeight : 500,
		},
	};
}

class ClockInEmployeeDialog extends FormComponent {
	constructor(props) {
		super(props);
		this.state = {
			isSaving : false,
			savingSuccessful : false,
			clockInDate : moment().format('YYYY-MM-DD'),
		};
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		if (prevState.shiftForUserId !== this.state.shiftForUserId) {
			this.fetchCurrentShift();
		}

		const { timeClockShift } = this.props;
		if (timeClockShift && prevProps.timeClockShift !== timeClockShift) {
			return this.setState({
				shiftForUserId : timeClockShift.shiftForUserId,
				lastTimeClockShift : timeClockShift,
			});
		}
	}

	fetchCurrentShift = () => {
		this.setState({ fetchingShifts: true, });

		const { shiftForUserId } = this.state;
		post({
			method: 'timeClockShift.manager.getLastShiftInfo',
			params: {
				shiftForUserIds : [shiftForUserId],
			},
			callback: (err, r) => {
				if (err) {
					return this.setState({
						fetchingShifts: false,
						searchErrors: err,
						lastTimeClockShift : null,
					});
				}

				const lastTimeClockShift = _.get(r, 'collections.timeClockShiftCollection.0');
				return this.setState({
					fetchingShifts: false,
					lastTimeClockShift
				});
			}
		});
	};


	handleSubmit = () => {
		const {timeClockShiftManagerClockIn, showErrors} = this.props;

		const formFieldError = {};
		_.values(this.requiredPathMap).forEach(({path, label}) => {
			if (!this.state[path]) {
				formFieldError[path] = `${label} is required`;
			}
		});
		if (_.keys(formFieldError).length) {
			this.setState({formFieldError});
			return showErrors(_.values(formFieldError));
		}

		this.setState({ isSaving: true, savingSuccessful : false });

		const {
			shiftForUserId,
			clockInDate, clockInTime,
			note, timeClockLocationId,
		} = this.state;

		const clockInMoment = moment(clockInDate);
		const timeMoment = moment(clockInTime);
		clockInMoment.hour(timeMoment.hour()).minute(timeMoment.minute());

		const params = {
			shiftForUserId,
			clockInDateTime : clockInMoment.utc().format('YYYY-MM-DD HH:mm:ss'),
			note,
			timeClockLocationId,
		};

		timeClockShiftManagerClockIn({
			params,
			callback: (err, apiResult) => {
				if (err) {
					this.setState({ isSaving : false });
					showErrors(err);
					return;
				}
				_.delay(() => {
					this.props.afterSave({ apiResult });
					this.handleClose();
				}, 400);
			}
		});
	};

	handleClose = () => {
		this.setState({
			savingSuccessful : false,
			isSaving : false,
		});
		this.props.onClose();
	};

	render() {
		const {
			open,
			classes,
			myCanModifyUserIds,
		} = this.props;

		const isRequired = true;
		const { isSaving, savingSuccessful, lastTimeClockShift } = this.state;

		let shiftIsBad = true;
		if (!lastTimeClockShift || lastTimeClockShift.clockOutDateTime) {
			shiftIsBad = false;
		}

		return (
			<Dialog
				open={open}
				TransitionComponent={Transition}
				onClose={this.handleClose}
				fullWidth={true}
				maxWidth={'md'}
				classes={{ scrollPaper : classes.dialogRoot }}
			>
				<div className={classes.inner}>
					<div className={classes.dialogTitle}>
						<div>
							Manually Clock In Employee
						</div>
						<div>
							<IconButton aria-label="close" className={classes.closeButton} onClick={this.handleClose}>
								<CloseIcon />
							</IconButton>
						</div>
					</div>

					<form>
						<Grid container spacing={2} style={{marginTop : 0, marginBottom : 0}}>
							<UserPicker
								{...this.setForm('shiftForUserId', 'Employee to clock in', isRequired)}
								helpText={"Only showing employees you have permission for"}
								userIdsToShow={myCanModifyUserIds}
								isPortal={true}
							/>

							{this.renderLastShift()}

							<FormDatePicker
								{...this.setForm('clockInDate', 'Clock in date', isRequired)}
								gridProps={{ md : 6}}
							/>

							<FormTimePicker
								{...this.setForm('clockInTime', 'Clock in time', isRequired)}
								gridProps={{ md : 6}}
							/>

							<TimeClockLocationSelect
								{...this.setForm('timeClockLocationId', 'Location of Clock In', isRequired)}
							/>

							<FormTextArea
								{...this.setForm('note', 'Reason for manager clock in', isRequired)}
								rows={2}
							/>

							<Grid item md={12} style={{display : 'flex', alignItems : 'baseline'}}>
								<Button
									variant="contained"
									color="primary"
									className={classes.addButton}
									onClick={this.handleSubmit}
									disabled={isSaving || savingSuccessful || shiftIsBad}
								>
									Clock In Employee
								</Button>

								<Button variant="outlined" className={classes.button} onClick={this.handleClose}>
									Close
								</Button>

								<Zoom
									in={isSaving}
									style={{ transitionDelay: isSaving ? '0ms' : '0ms' }}
									mountOnEnter unmountOnExit
								>
									<div className={classes.isSaving}>
										<CircularProgress style={{verticalAlign : 'middle'}} />
										<span style={{paddingLeft: 10}}>Saving...</span>
									</div>
								</Zoom>

								<Zoom in={savingSuccessful} style={{ transitionDelay: savingSuccessful ? '250ms' : '0ms' }}>
									<div className={classes.savingSuccessful}>
										<div className={classes.greenCheckedIcon}/>
										<span style={{paddingLeft: 10}}>Employee clocked in successfully.</span>
									</div>
								</Zoom>
							</Grid>
						</Grid>
					</form>
				</div>
			</Dialog>
		);
	}

	renderLastShift = () => {

		const { classes } = this.props;
		const { shiftForUserId, fetchingShifts, lastTimeClockShift } = this.state;

		if (!shiftForUserId) {
			return (
				<Grid item xs={12} >
					<div className={classes.currentShiftContainer}>
						<div className={classes.pleaseSelect}>
							Pick an employee to show their last shift.
						</div>
					</div>
				</Grid>
			);
		}

		if (fetchingShifts) {
			return (
				<Grid item xs={12} >
					<div className={classes.currentShiftContainer}>
						<div className={classes.currentShiftTitle}>
							<CircularProgress style={{verticalAlign : 'middle'}} />
							<span style={{paddingLeft: 10}}>Fetching current shift...</span>
						</div>
					</div>
				</Grid>
			);
		}

		if (!lastTimeClockShift) {
			return (<Grid item xs={12} >
				<div className={classes.currentShiftContainer}>
					<div className={classes.currentShiftTitle}>
						No record of this employee ever clocking in.
					</div>
				</div>
			</Grid>);
		}

		const { clockOutDateTime} = lastTimeClockShift;
		if (!clockOutDateTime) {
			return (<Grid item xs={12} >
				<div className={classes.currentShiftContainer}>
					<div className={classes.currentShiftTitle}>
						<ErrorIcon className={classes.errorIcon}/>
						Employee is currently clocked in.
					</div>
				</div>
			</Grid>);
		}

		const clockOutMoment = moment(clockOutDateTime);
		const duration = moment.duration(moment().diff(clockOutMoment));

		return (<Grid item xs={12} >
			<div className={classes.currentShiftContainer}>
				<div className={classes.currentShiftTitle}>
					<div className={classes.greenCheckedIcon}/> Employee is currently clocked out
				</div>
				<div style={{marginTop : 7, paddingTop : 7, borderTop : '1px solid #ddd' }}>
					<span className={classes.currentLabel}>Clock out date / time : </span>
					<span className={classes.currentValue}>{clockOutMoment.format('M/D h:mm a')}</span>
				</div>
				<div style={{marginTop : 5}}>
					<span className={classes.currentLabel}>Clocked out for : </span>
					<span className={classes.currentValue}>
						{moment.duration(duration).format('d [days], h [hrs], m [min]')}
					</span>
				</div>
			</div>
		</Grid>);
	}

}

ClockInEmployeeDialog.propTypes = {
	open : PropTypes.bool,
	onClose : PropTypes.func,
	myCanModifyUserIds : PropTypes.array,
	timeClockShiftManagerClockIn : PropTypes.func.isRequired,
	afterSave : PropTypes.func.isRequired,
};

export default _.flow([
	withStyles(styles, { withTheme: true }),
	AuthUserContainer,
	TimeClockContainer,
])(ClockInEmployeeDialog);
